import React from 'react';

export const SubscriptionSkeleton = () => {
    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 bg-white rounded-lg shadow animate-pulse gap-4">
            {/* Left side - Icon and subscription details */}
            <div className="flex items-center w-full sm:w-auto">
                <div className="w-10 h-10 rounded-full bg-gray-200 mr-4 flex-shrink-0" />
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                        <div className="h-4 w-32 bg-gray-200 rounded" />
                        <div className="h-4 w-16 bg-gray-200 rounded-full" />
                    </div>
                    <div className="h-3 w-48 bg-gray-200 rounded mt-2" />
                </div>
            </div>

            {/* Right side - Price and actions */}
            <div className="flex items-center justify-between w-full sm:w-auto">
                <div className="text-left sm:text-right sm:mr-4">
                    <div className="h-4 w-20 bg-gray-200 rounded mb-2" />
                    <div className="h-3 w-16 bg-gray-200 rounded" />
                </div>
                <div className="flex items-center space-x-2">
                    <div className="h-8 w-8 bg-gray-200 rounded" />
                    <div className="h-8 w-16 bg-gray-200 rounded" />
                </div>
            </div>
        </div>
    );
}; 